import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  colore_aste: "",
  colore_frame: "",
  colore_lenti: "",
  esa_color_frame_primary: "",
  esa_color_frame_secondary: "",
  esa_color_lenses_primary: "",
  esa_color_lenses_secondary: "",
  nome_occhiale: "",
  url_glb: "",
  url_glb_complete: "",
  url_usdz: "",
  url_usdz_complete: "",
};

const modello = createSlice({
  name: "modello",
  initialState,
  reducers: {
    setModello(state, action) {
      const {coloreAste, coloreFrame, coloreLenti, esaColorFPrimary, esaColorFSecondary, esaColorLPrimary, esaColorLSecondary, nomeOcchiale, urlGlb, urlGlbComplete, urlUsdz, urlUsdzComplete} = action.payload;
      state.colore_aste = coloreAste;
      state.colore_frame = coloreFrame;
      state.colore_lenti = coloreLenti;
      state.esa_color_frame_primary = esaColorFPrimary;
      state.esa_color_frame_secondary = esaColorFSecondary;
      state.esa_color_lenses_primary = esaColorLPrimary;
      state.esa_color_lenses_secondary = esaColorLSecondary;
      state.nome_occhiale = nomeOcchiale;
      state.url_glb = urlGlb;
      state.url_glb_complete = urlGlbComplete;
      state.url_usdz = urlUsdz;
      state.url_usdz_complete = urlUsdzComplete;
    }
  },
});

export const modelloActions = modello.actions;

export default modello.reducer;
